import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
/**
 * @author wuluoting
 * @fileoverview 底部信息-PC
 */

import { defineComponent, provide } from "vue";
// assets
import gwUrl from "@/assets/img/common/gw.png";
import sqUrl from "@/assets/img/common/sq.png";
import gzhUrl from "@/assets/img/common/gzh.png";
import qlUrl from "@/assets/img/common/ql.png";
import kt2Url from "@/assets/img/pc/footer-kv.png";
import dyUrl from "@/assets/img/common/dy.png";
// components
import publicSafetyIconUrl from "@/assets/img/common/public_safety_icon.png";
export default defineComponent({
  name: "FooterPC",
  setup() {
    provide();
    return () => {
      return _createVNode("div", {
        "class": "pc-explain global-footer"
      }, [_createVNode("img", {
        "class": "kt2",
        "src": kt2Url
      }, null), _createVNode("div", {
        "class": "connect"
      }, [_createVNode("a", {
        "href": "https://cahx.shiyue.com/",
        "target": "_blank"
      }, [_createVNode("img", {
        "src": gwUrl
      }, null)]), _createVNode("a", {
        "href": "http://30374.m.url29.com.cn/m_applet?short=mAsc8m&domain=a.eturl.cn&uck=b2e19c0ad8982472f0f039ed41c2771b",
        "target": "_blank"
      }, [_createVNode("img", {
        "src": qlUrl
      }, null)]), _createVNode("a", {
        "href": "https://m.sysl.cc/I0UgrNh",
        "target": "_blank"
      }, [_createVNode("img", {
        "src": sqUrl
      }, null)]), _createVNode("a", {
        "href": "https://mp.weixin.qq.com/s/bLQRJe_Oo1_qL9ZHW9k2Mw",
        "target": "_blank"
      }, [_createVNode("img", {
        "src": gzhUrl
      }, null)]), _createVNode("a", {
        "href": "https://www.douyin.com/user/MS4wLjABAAAAhYrpTi9YCwkjD70O2p1XmYGgyUdaDa1OcY6RhHcjYD8dg05AIVlB5HW7wolzEHx7?from_tab_name=main",
        "target": "_blank"
      }, [_createVNode("img", {
        "src": dyUrl
      }, null)])]), _createVNode("div", {
        "class": "footer-panel"
      }, [_createVNode("section", {
        "class": "info-item"
      }, [_createTextVNode("\u5E7F\u5DDE\u8BD7\u60A6\u7F51\u7EDC\u79D1\u6280\u6709\u9650\u516C\u53F8 \u7248\u6743\u6240\u6709 Copyright \xA9 2022 shiyue.com. All Rights Reserved.")]), _createVNode("section", {
        "class": "info-item"
      }, [_createTextVNode("\u516C\u53F8\u5730\u5740\uFF1A\u5E7F\u5DDE\u5E02\u5929\u6CB3\u533A\u79D1\u97F5\u8DEF36-38\u53F7 \u4E09\u697C"), _createVNode("a", {
        "href": "https://www.shiyue.com/article_detail_10_37.html"
      }, [_createTextVNode("\u9690\u79C1\u534F\u8BAE")]), _createVNode("span", null, [_createTextVNode("\uFF5C")]), _createVNode("a", {
        "href": "https://www.shiyue.com/article_detail_10_37.html"
      }, [_createTextVNode("\u7528\u6237\u534F\u8BAE")]), _createVNode("span", null, [_createVNode("a", {
        "href": "https://www.shiyue.com/article_detail_10_865.html"
      }, [_createTextVNode("\u672A\u6210\u5E74\u4EBA\u6210\u957F\u5B88\u62A4\u8BA1\u5212")]), _createVNode("span", null, [_createTextVNode("\uFF5C")]), _createVNode("a", {
        "href": "https://www.shiyue.com/article_detail_10_43.html"
      }, [_createTextVNode("\u4EA4\u6613\u7EA0\u7EB7\u5904\u7406\u5185\u5BB9")]), _createVNode("span", null, [_createTextVNode("\uFF5C")]), _createVNode("a", {
        "href": "https://www.shiyue.com/about.html"
      }, [_createTextVNode("\u5173\u4E8E\u6211\u4EEC")]), _createVNode("span", null, [_createTextVNode("\uFF5C")]), _createVNode("a", {
        "href": "https://kf.shiyue.com"
      }, [_createTextVNode("\u5BA2\u670D\u4E2D\u5FC3")])])]), _createVNode("section", {
        "class": "info-item"
      }, [_createVNode("span", null, [_createTextVNode("\u51FA\u7248\u7269\u53F7\uFF1AISBN 978-7-498-04567-6")]), _createVNode("span", null, [_createTextVNode("\u5F00\u53D1\u8005\uFF1A\u5E7F\u5DDE\u8BD7\u60A6\u7F51\u7EDC\u79D1\u6280\u6E38\u620F\u516C\u53F8")]), _createVNode("span", null, [_createTextVNode("\u5E94\u7528\u7248\u672C\uFF1A8.3.1.102211909")]), _createVNode("span", {
        "style": {
          marginLeft: "16px"
        }
      }, [_createTextVNode("\u66F4\u65B0\u65E5\u671F\uFF1A2023/2/24")])]), _createVNode("section", {
        "class": "info-item"
      }, [_createVNode("span", null, [_createTextVNode("\u7CA4\u7F51\u6587\u30102018\u30119214-3272\u53F7")]), _createVNode("span", {
        "style": {
          marginLeft: "16px"
        }
      }, null), _createVNode("img", {
        "src": publicSafetyIconUrl,
        "width": "15",
        "height": "15",
        "style": {
          marginRight: "6px",
          verticalAlign: "sub"
        }
      }, null), _createVNode("span", null, [_createTextVNode("\u7CA4ICP\u5907\uFF1A15004121\u53F7")])]), _createVNode("div", {
        "class": "company-logo bg-contain"
      }, null)])]);
    };
  }
});